import { Outlet } from 'react-router-dom';
import { SkipToContent } from '@/components/SkipToContent';
import { Footer } from '@/components/Footer';
import { privateMeta } from '@/lib/seo/site';
import { useSeoHead } from '@/lib/seo/useSeoHead';
import { PublicLayoutHeader } from './PublicLayoutHeader';

// Auth pages share the full public header for navigation parity (resolved
// during UX-1) and the full <Footer /> for cross-page harmonisation
// (2026-05-10 user request). FloatingCTAActions is still hidden on these
// routes per UI Behavior §6.1 + ADR-031; the FAB lives only inside
// PublicLayout / BuyerLayout. AdminLoginPage is intentionally extracted
// into its own AdminLoginLayout (Spec V1.1 §5.7 — no public header/footer).
export function AuthLayout() {
  useSeoHead(privateMeta('Account'));
  return (
    <div className="layout layout--auth">
      <SkipToContent />
      <PublicLayoutHeader />

      <main id="main-content" className="layout__main layout__main--centered" tabIndex={-1}>
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}
